<template>
    <p style="margin-top: 1rem; font-size: 0.875rem">
        <template v-if="!hasCustomDeliveryTime">
      <span>{{ stockText }}</span
      >&nbsp;<span>{{ $t("defaultDeliveryText") }}</span>
        </template>
        <template v-else>
      <span
      >{{
              t("customDeliveryText", {
                  time: customDeliveryTime,
                  unit: customDeliveryTimeUnit,
              })
          }}
      </span>
        </template>
    </p>
</template>

<script lang="ts">
import { computed, defineComponent, ref } from "vue";
import { useI18n } from "vue-i18n";
import useProductQuery from "@/composables/useProductQuery";
import useStore from "@/composables/useStore";

const QUANTITY_THRESHOLD = 5;

export default defineComponent({
    setup() {
        const { t } = useI18n();
        const store = useStore();

        const productQuery = useProductQuery();

        function translateDeliveryTimeUnit(unit?: string) {
            switch (unit) {
                case "Tage":
                    return t("deliveryUnitDays");
                case "Wochen":
                    return t("deliveryUnitWeeks");
                default:
                    return unit;
            }
        }

        const productData = ref();
        productQuery(
            window.location.pathname.match(/products\/(.*)/)?.[1] ?? "",
            // @ts-expect-error
            window.Shopify.locale.toUpperCase(),
            // @ts-expect-error
            window.Shopify.country.toUpperCase(),
        ).then((data) => (productData.value = data));

        const selectedBaseVariant = computed(
            () =>
                // @ts-expect-error
                productData?.value?.product?.variants.nodes.find((node) =>
                    node.id.includes(store.state.variantId),
                ),
        );

        const stockText = computed(() => {
            if (
                !selectedBaseVariant.value ||
                !selectedBaseVariant.value.quantityAvailable
            ) {
                return t("stockAvailable");
            }

            if (selectedBaseVariant.value.quantityAvailable > QUANTITY_THRESHOLD) {
                return t("stockAvailable");
            } else if (selectedBaseVariant.value.quantityAvailable > 0) {
                return t("stockLow");
            } else {
                return t("noStock");
            }
        });

        const productCustomDeliveryTime = computed(
            () => productData?.value?.product?.deliveryTime?.value,
        );
        const productCustomDeliveryTimeUnit = computed(
            () => productData?.value?.product?.deliveryTimeUnit?.value,
        );

        const variantCustomDeliveryTime = computed(
            () => selectedBaseVariant.value?.deliveryTime?.value,
        );
        const variantCustomDeliveryTimeUnit = computed(
            () => selectedBaseVariant.value?.deliveryTimeUnit?.value,
        );

        const hasCustomDeliveryTime = computed(
            () => productCustomDeliveryTime.value || variantCustomDeliveryTime.value,
        );

        const customDeliveryTime = computed(() =>
            hasCustomDeliveryTime.value
                ? productCustomDeliveryTime.value ?? variantCustomDeliveryTime.value
                : null,
        );
        const customDeliveryTimeUnit = computed(() =>
            hasCustomDeliveryTime.value
                ? translateDeliveryTimeUnit(
                    productCustomDeliveryTimeUnit.value ??
                    variantCustomDeliveryTimeUnit.value,
                )
                : null,
        );

        return {
            t,
            hasCustomDeliveryTime,
            stockText,
            customDeliveryTime,
            customDeliveryTimeUnit,
            productData,
        };
    },
});
</script>
